<template>
  <form-group :validations="validation" class="w-100">
    <div slot-scope="{ errors, invalid }">
      <div class="form-group">
        <label>{{ label }}</label>
        <textarea :value="inputValue" @input="updateValue" :class="{invalid}" class="form-control" :rows="rowsCount"></textarea>
      </div>
      <form-errors-manager :errors="errors" />
    </div>
  </form-group>
</template>
<script>
import FormGroup from "../../../validator/FormGroup.vue";
import FormErrorsManager from "../../../validator/FormErrorsManager.vue";
export default {
  name: "FormTextArea",
  components: { FormGroup, FormErrorsManager },
  props: ["validation", "inputValue", "label","rowsCount"],
  model: {
    prop: 'inputValue',
    event: 'input'
  },
  methods: {
    updateValue(event) {
      this.$emit('input', event.target.value)
    }
  },
};
</script>